import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
	getAvailableEquipment: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].GET_AVAILABLE_EQUIPMENT,
	},
	getFullEquipment: {
		useCache: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].GET_AVAILABLE_EQUIPMENT,
	},
	getBasedEquipment: {
		useCache: true,
		cacheStorage: STORE_MAP.BASE,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].GET_AVAILABLE_EQUIPMENT,
	},
	getExtendedEquipment: {
		useCache: true,
		cacheStorage: STORE_MAP.EXTENDED,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].GET_AVAILABLE_EQUIPMENT,
	},
	getEquipment: {
		useCache: true,
		isSingleCachedEntity: true,
		cacheStorage: STORE_MAP.FULL,
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].GET_EQUIPMENT,
	},
	getPreviewEquipment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].GET_PREVIEW_EQUIPMENT,
	},
	getPopupEquipment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].GET_POPUP_EQUIPMENT,
	},
	createEquipment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].CREATE_EQUIPMENT,
	},
	patchEquipment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].PATCH_EQUIPMENT,
	},
	putEquipment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].PUT_EQUIPMENT,
	},
	deleteEquipment: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.EQUIPMENT].DELETE_EQUIPMENT,
	},
}
